module.exports = __webpack_public_path__ + "static/titulo-2-modal-fidelizacion-a9c50b1464c62d21b41e0f77b350b095.svg";